import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 transition-all duration-300">
      <nav className="bg-background-50/95 backdrop-blur-md border-b border-background-200/70">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="text-xl font-heading font-bold text-foreground-950">屁屁影院</span>
            </Link>

            <div className="hidden md:flex items-center gap-8">
              <Link
                to="/"
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                  isActive('/') ? 'text-primary-500' : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                首页
              </Link>
              <Link
                to="/category/all"
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                  location.pathname.startsWith('/category') ? 'text-primary-500' : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                分类
              </Link>
              <Link
                to="/about"
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                  isActive('/about') ? 'text-primary-500' : 'text-foreground-700 hover:text-foreground-950'
                }`}
              >
                关于我们
              </Link>
            </div>

            <div className="hidden md:flex items-center gap-4">
              <div className="relative">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="搜索电影..."
                  className="w-56 pl-9 pr-4 py-2 text-sm bg-background-100 border border-background-300/60 rounded-full text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                />
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              </div>
            </div>

            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 cursor-pointer"
            >
              <i className={`text-lg text-foreground-700 ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
            <div className="flex flex-col gap-3">
              <Link
                to="/"
                onClick={() => setIsMenuOpen(false)}
                className={`text-sm font-medium px-3 py-2 rounded-lg whitespace-nowrap cursor-pointer ${
                  isActive('/') ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                首页
              </Link>
              <Link
                to="/category/all"
                onClick={() => setIsMenuOpen(false)}
                className={`text-sm font-medium px-3 py-2 rounded-lg whitespace-nowrap cursor-pointer ${
                  location.pathname.startsWith('/category') ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                分类
              </Link>
              <Link
                to="/about"
                onClick={() => setIsMenuOpen(false)}
                className={`text-sm font-medium px-3 py-2 rounded-lg whitespace-nowrap cursor-pointer ${
                  isActive('/about') ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                关于我们
              </Link>
              <div className="relative mt-2">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="搜索电影..."
                  className="w-full pl-9 pr-4 py-2.5 text-sm bg-background-100 border border-background-300/60 rounded-full text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300"
                />
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}